import { ChevronDownIcon, ChevronUpIcon } from "@primer/octicons-react";
import { Box, IconButton, Label } from "@primer/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCommonContext } from "../../contexts/common";
import { ePageBaseStatus } from "../../models/ePageBaseStatus";
import { ICrmSurveyFormQuestion } from "../../models/response/crm-survey/ICrmSurveyFormQuestion";
import { actions } from "../../state/actions/actionsWrapper";
import { RootState } from "../../state/reducers";
interface ISurveyFormBlockProps {
  formQuestionSelectedIds: number[];
  children: React.ReactNode;
  isFocused?: boolean;
  elementKey?: string;
  onFocused?: (elementKey: string) => void;
  // refIni?: any,
  onDragStart?: (e: any) => void;
  onDragOver?: (e: any) => void;
  onDragEnd?: (e: any) => void;
  // onAddNew?: () => void;
  onAddFormExisted?: (questions: ICrmSurveyFormQuestion[]) => void;
  onValueChanged?: (ids: number[]) => void;
  isDragOver?: boolean;
  isDragging?: boolean;
  onMoveUp?: () => void;
  onMoveDown?: () => void;
  canMoveUp?: boolean;
  canMoveDown?: boolean;
  isMapped?: boolean;
}

const SurveyFormBlock = (props: ISurveyFormBlockProps) => {
  const dispatch = useDispatch();
  const { translate } = useCommonContext();
  const { status, crmSurveyFormQuestions } = useSelector(
    (x: RootState) => x.crmSurvey.crmSurveyFormQuestion
  );


  useEffect(() => {
    if (status === ePageBaseStatus.is_not_initialization) {
      dispatch(actions.crmSurveyFormWrapper.crmSurveyFormQuestion.CHANGE_SELECTED_IDS([]));
      dispatch(actions.crmSurveyFormWrapper.crmSurveyFormQuestion.LOAD_START(''));
    }
  }, [status]);


  return (
    <Box>
      <Box
        sx={{ position: "relative", display: "flex", flexDirection: "column" }}
      >
        {/* Dòng màu xanh hiển thị vị trí sẽ thả vào */}
        {props.isDragOver && (
          <Box
            sx={{
              height: "4px",
              backgroundColor: "#0969da",
              borderRadius: "2px",
              mb: 2,
              boxShadow: "0 0 8px rgba(9, 105, 218, 0.3)",
            }}
          />
        )}
        
        {/* Thanh màu xanh bên trái khi focus */}
        {props.isFocused && (
          <Box
            sx={{
              ml: "-8px",
              position: "absolute",
              height: "100%",
              pt: 2,
              pb: 3,
            }}
          >
            <Box
              sx={{
                backgroundColor: "#0969da",
                width: "8px",
                height: "100%",
                borderTopLeftRadius: "8px",
                borderBottomLeftRadius: "8px",
              }}
            >
              &nbsp;
            </Box>
          </Box>
        )}
        
        <Box
          sx={{
            position: "relative",
            border: "1px solid",
            borderRadius: 2,
            borderColor: props.isDragging ? "#0969da" : "border.default",
            borderStyle: props.isDragging ? "dashed" : "solid",
            backgroundColor: "#ffff",
            p: 3,
            pl: 3,
            pr: 3,
            mb: 2,
            flex: 1,
            cursor: props.onDragStart ? "pointer" : "default",
            opacity: props.isDragging ? 0.5 : 1,
            transition: "all 0.2s ease",
          }}
          draggable={Boolean(props.onDragStart)}
          onClick={() => {
            if (props.onFocused) {
              props.onFocused(props.elementKey ?? "");
            }
          }}
          id={props.elementKey}
          onDragStart={props.onDragStart}
          onDragOver={props.onDragOver}
          onDragEnd={props.onDragEnd}
          onDrop={(e) => {
            e.preventDefault();
          }}
        >
          {(props.isMapped || (props.onMoveUp && props.onMoveDown)) && (
            <Box
              sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1, mb: 1 }}
              onClick={(e) => e.stopPropagation()}
            >
              <Box>
                {props.isMapped && <Label variant="success">{translate("Cố định")}</Label>}
              </Box>
              <Box sx={{ display: "flex", gap: 1 }}>
              <IconButton
                icon={ChevronUpIcon}
                aria-label="Lên trên"
                variant="invisible"
                sx={{ bg: "neutral.muted" }}
                size="small"
                disabled={!props.canMoveUp}
                onClick={props.onMoveUp}
              />
              <IconButton
                icon={ChevronDownIcon}
                aria-label="Xuống dưới"
                variant="invisible"
                sx={{ bg: "neutral.muted" }}
                size="small"
                disabled={!props.canMoveDown}
                onClick={props.onMoveDown}
              />
              </Box>
            </Box>
          )}
          {props.children}
        </Box>
      </Box>
    </Box>
  );
};

export default SurveyFormBlock;
